__turbopack_context__.v({
  "image-section": "image-section-component-module-scss-module__RFGJfW__image-section",
  "image-section__image": "image-section-component-module-scss-module__RFGJfW__image-section__image",
});
